<form [formGroup]="form">
  <!-- Sección: Tipo de vía -->
  <div class="form__flexGap">
    <div class="form__flexGapItem form__flexGapItem--40">
      <div class="form__sublabel">Tipo de vía</div>
      <div class="form__group">
        <div class="p-float-label">
          <p-dropdown
            [options]="roadTypeOptions"
            [filter] = "true"
            (onChange)="onGenerateDataToSave()"
            optionLabel="label"
            optionValue="value"
            formControlName="road_type"
            placeholder="Selecciona...">
          </p-dropdown>
          <label>Nombre *</label>
        </div>
      </div>
    </div>

    <div class="form__flexGapItem">
      <div class="form__sublabel">Número de vía</div>
      <div class="form__flexGap">
        <div class="form__flexGapItem">
          <div class="form__group">
            <div class="p-float-label">
              <p-inputNumber
                inputId="road_number"
                formControlName="road_number"
                (onBlur)="onGenerateDataToSave()"
                [min]="0"
                [max]="999"
                [allowEmpty]="true"
                [useGrouping]="false">
              </p-inputNumber>
              <label for="road_number">Número *</label>
            </div>
            <span class="form__msgError" *ngIf="isSubmitted() && !form.get('road_number')?.value && !form.get('road_number')?.value">
                      <small class="p-error">Requerido*</small>
                    </span>
          </div>
        </div>

        <div class="form__flexGapItem">
          <div class="form__group">
            <div class="p-float-label">
              <input pInputText type="text" formControlName="road_lyric" (blur)="onGenerateDataToSave()" />
              <label>Letras</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Sección: Número de cruce y predio -->
  <div class="form__flexGap">
    <div class="form__flexGapItem">
      <div class="form__sublabel">Número de cruce y predio</div>
      <div class="form__flexGap form__flexGap--minGap">
        <div class="form__flexGapItem form__flexGapItem--separator"><span>#</span></div>

        <div class="form__flexGapItem">
          <div class="form__flexGap">
            <div class="form__flexGapItem form__flexGapItem--40">
              <div class="form__group">
                <div class="p-float-label">
                  <p-inputNumber
                    inputId="road_number"
                    formControlName="cruce_number"
                    (onBlur)="onGenerateDataToSave()"
                    [min]="0"
                    [max]="999"
                    [allowEmpty]="true"
                    [useGrouping]="false">
                  </p-inputNumber>
                  <label>Número *</label>
                </div>
                <span class="form__msgError" *ngIf="isSubmitted() && !form.get('cruce_number')?.value && !form.get('cruce_number')?.value">
                      <small class="p-error">Requerido*</small>
                    </span>
              </div>
            </div>

            <div class="form__flexGapItem">
              <div class="form__group">
                <div class="p-float-label">
                  <input pInputText type="text" formControlName="cruce_lyric" (blur)="onGenerateDataToSave()"  />
                  <label>Letras</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form__flexGapItem form__flexGapItem--separator"><span>-</span></div>

        <div class="form__flexGapItem">
          <div class="form__flexGap">
            <div class="form__flexGapItem form__flexGapItem--40">
              <div class="form__group">
                <div class="p-float-label">
                  <p-inputNumber
                    inputId="road_number"
                    formControlName="cruce_number_sub"
                    [min]="0"
                    [max]="999"
                    [allowEmpty]="true"
                    [useGrouping]="false">
                  </p-inputNumber>
                  <label>Número *</label>
                </div>
                <span class="form__msgError" *ngIf="isSubmitted() && !form.get('cruce_number_sub')?.value && !form.get('cruce_number_sub')?.value">
                      <small class="p-error">Requerido*</small>
                    </span>
              </div>
            </div>

            <div class="form__flexGapItem">
              <div class="form__group">
                <div class="p-float-label">
                  <input pInputText type="text" formControlName="cruce_lyric_sub" (blur)="onGenerateDataToSave()" />
                  <label>Letras</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Sección: Complemento -->
  <div class="form__flexGap">
    <div class="form__flexGapItem">
      <div class="form__sublabel">Complemento</div>
      <div class="form__group">
        <div class="p-float-label">
          <input pInputText type="text" formControlName="cruce_complement" (blur)="onGenerateDataToSave()" />
          <label>Detalle</label>
        </div>
      </div>
    </div>
  </div>
</form>
